import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { secureFetch } from "../utils/secureFetch";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function DeleteAccount() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const loggedIn = Boolean(localStorage.getItem("beercard_access_token"));

  const requestDeletion = async () => {
    const confirmed = window.confirm(
      "Request account deletion? Your account will be disabled immediately and you will be logged out."
    );
    if (!confirmed) return;

    setSubmitting(true);
    setError("");

    try {
      await secureFetch(`${API_BASE}/account/deletion-request`, {
        method: "POST",
        body: JSON.stringify({})
      });
      localStorage.clear();
      alert("Your account has been disabled and your deletion request recorded.");
      navigate("/login", { replace: true });
    } catch (err) {
      setError("We could not submit your request. Please contact support.");
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#F7F4EA] px-4 py-8 text-[#1E2A38]">
      <div className="mx-auto max-w-2xl rounded-2xl bg-white p-6 shadow-md md:p-10">
        <h1 className="text-3xl font-bold">Delete your TeamKitty account</h1>
        <p className="mt-4">
          You can request deletion from this page. When submitted while signed
          in, your account is disabled immediately and scheduled for deletion.
        </p>
        <p className="mt-4">
          Personal profile data will be deleted. Limited payment or transaction
          records may be retained where required for legal, fraud-prevention,
          accounting, or audit obligations.
        </p>

        {loggedIn ? (
          <button
            type="button"
            disabled={submitting}
            onClick={requestDeletion}
            className="mt-6 w-full rounded-lg bg-red-700 px-4 py-3 font-bold text-white disabled:opacity-50"
          >
            {submitting ? "Submitting request..." : "Request account deletion"}
          </button>
        ) : (
          <div className="mt-6 rounded-lg border border-slate-200 bg-slate-50 p-4">
            <p>
              Sign in to verify ownership and submit the request immediately.
            </p>
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="mt-3 rounded bg-[#0B1C2C] px-4 py-2 font-bold text-white"
            >
              Sign in
            </button>
          </div>
        )}

        {error && <p className="mt-4 text-red-700">{error}</p>}

        <p className="mt-6 text-sm text-slate-600">
          If you cannot sign in, email{" "}
          <a className="underline" href="mailto:contact@teamkitty.io?subject=Account deletion request">
            contact@teamkitty.io
          </a>{" "}
          from the address registered to your TeamKitty account.
        </p>
      </div>
    </main>
  );
}
